<template>
  <div
    class="flex items-end w-full rounded-xl border bg-white transition-colors duration-150"
    :class="[
      isFocused ? 'border-gray-300' : 'border-gray-200',
      disabled ? 'opacity-50 pointer-events-none' : ''
    ]"
  >
    <button
      type="button"
      class="flex-shrink-0 p-3 text-gray-400 hover:text-gray-600 transition-colors"
      @click="triggerUpload"
      :disabled="disabled"
      title="파일 첨부"
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
        <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/>
      </svg>
    </button>

    <textarea
      ref="textareaRef"
      v-model="message"
      class="flex-1 resize-none bg-transparent border-none outline-none text-[14px] leading-relaxed max-h-[160px] overflow-y-auto py-3 placeholder:text-gray-400"
      :disabled="disabled"
      :placeholder="placeholder"
      @keydown="handleKeydown"
      @input="autoResize"
      @focus="isFocused = true"
      @blur="isFocused = false"
      rows="1"
    ></textarea>

    <button
      type="button"
      :disabled="disabled || !message.trim()"
      class="flex-shrink-0 m-2 p-2 rounded-lg transition-colors"
      :class="message.trim() && !disabled
        ? 'bg-gray-800 text-white hover:bg-black'
        : 'bg-gray-100 text-gray-300'"
      @click="onSend"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="12" y1="19" x2="12" y2="5"></line>
        <polyline points="5 12 12 5 19 12"></polyline>
      </svg>
    </button>
  </div>
</template>

<script setup>
import { ref, nextTick } from 'vue';

defineProps({
  disabled: { type: Boolean, default: false },
  placeholder: { type: String, default: '메시지 입력...' }
});
const emits = defineEmits(['send', 'trigger-upload']);

const textareaRef = ref(null);
const message = ref('');
const isFocused = ref(false);

function handleKeydown(e) {
  if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); onSend(); }
}
function onSend() {
  const val = message.value.trim();
  if (!val) return;
  emits('send', val);
  message.value = '';
  nextTick(() => { autoResize(); textareaRef.value?.focus(); });
}
function autoResize() {
  const t = textareaRef.value; if (!t) return;
  t.style.height = 'auto';
  t.style.height = `${Math.min(t.scrollHeight, 160)}px`;
}
function triggerUpload() { emits('trigger-upload'); }
</script>

<style scoped>
textarea::-webkit-scrollbar { width: 4px; }
textarea::-webkit-scrollbar-track { background: transparent; }
textarea::-webkit-scrollbar-thumb { background-color: #d4d4d4; border-radius: 4px; }
</style>
